import { render, staticRenderFns } from "./AdminUploadDocuments.vue?vue&type=template&id=31be1528&scoped=true&"
import script from "./AdminUploadDocuments.vue?vue&type=script&lang=js&"
export * from "./AdminUploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AdminUploadDocuments.vue?vue&type=style&index=0&id=31be1528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be1528",
  null
  
)

export default component.exports